<ion-app>
  <app-rs-headers></app-rs-headers>
  <div class="main-container">
    <div class="rishta-menu">
      <app-rs-menu/>
    </div>
    <div class="content">
      <ion-router-outlet></ion-router-outlet>
    </div>
  </div>
</ion-app>
